import { FC } from 'react';
import { CatBadge } from '@blocks-react/components/Badge';
import { HeaderCartProps } from './types';
import { HeaderNavItem } from '../header-nav-item/HeaderNavItem';
import { Conditional } from '../../common';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';
import { CatIconShop } from 'blocks-nextjs/blocks-react/components/Icons/Shop';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import cx from 'classnames';
import styles from '../Header.module.scss';

export const HeaderCart: FC<HeaderCartProps> = ({
  cartItems,
  handleDrawerProps,
  id,
  isCurrent,
  title,
  redirectionLink,
  isPartsDiagramV2 = false
}) => {
  return (
    <Conditional
      test={!isPartsDiagramV2}
      fallback={
        <CatButton
          slot="actions"
          variant="ghost"
          href={redirectionLink}
          className={
            typeof cartItems === 'number' && cartItems > 0
              ? 'cart-has-badge'
              : ''
          }
          data-track-event="e_primaryCTA"
          data-track-attr-nltext="shopping cart icon"
          data-track-attr-context="Parts Diagram page header section"
        >
          <span className="m-0">
            {(cartItems === '...' ||
              (typeof cartItems === 'number' && cartItems > 0)) && (
              <CatBadge
                position="top-right"
                text={cartItems?.toString()}
                data-testid="cat-header-cart-badge"
                className={cx(styles['cat-part-diagram-cart-badge'])}
              />
            )}

            <CatIconShop slot="after" color="content-strong" size="lg" />
          </span>
        </CatButton>
      }
    >
      <HeaderNavItem
        aria-label={title}
        data-testid="cat-header-cart-icon"
        id={id}
        isCurrent={isCurrent}
        title={title}
        href={redirectionLink}
        role="menu"
        {...handleDrawerProps}
        data-track-event={MAIN_NAV_TRACK.EVENT}
        data-track-attr-nltext={MAIN_NAV_TRACK.SHOPPING_CART_TEXT}
        data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      >
        <span className="m-0">
          <Conditional test={cartItems === '...' || (cartItems as number) > 0}>
            <CatBadge
              position="top-right"
              text={cartItems?.toString()}
              variant="brand"
              data-testid="cat-header-cart-badge"
            />
          </Conditional>

          <div className=" d-md-none">
            <CatIconShop size="lg" />
          </div>
          <div className="d-none d-md-block d-lg-none">
            <CatIconShop size="lg" />
          </div>
          <div className=" d-none d-lg-block">
            <CatIconShop />
          </div>
        </span>
      </HeaderNavItem>
    </Conditional>
  );
};
